import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Input } from '../../../../common/Input';
import { ContactField } from '../../styles';
import { ContactFieldInputProps } from './types';
import { ExtendedMarkerData } from '../../../../../types/marker';

/**
 * Composant générique pour un champ de contact avec icône
 * Gère automatiquement la synchronisation entre formData et contacts[0]
 */
export const ContactFieldInput: React.FC<ContactFieldInputProps> = ({
  config,
  formData,
  setFormData,
  error,
  isReadOnly = false
}) => {
  const { key, contactKey, placeholder, icon: Icon, type = 'text' } = config;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    const updatedContacts = [...(formData.contacts || [])];
    
    // Créer ou mettre à jour le premier contact
    if (updatedContacts.length === 0) {
      // Créer un nouveau contact avec toutes les données existantes
      const newContact: any = {
        id: uuidv4(),
        name: formData.name || '',
        firstName: formData.firstName || '',
        type: 'owner',
        address: formData.contact_address || '',
        phone: formData.phone || '',
        email: formData.email || '',
        designation: 'contact' // Valeur par défaut
      };
      
      // Mettre à jour le champ spécifique
      (newContact as any)[contactKey] = newValue;
      updatedContacts.push(newContact);
    } else {
      // Mettre à jour le contact existant
      updatedContacts[0] = {
        ...updatedContacts[0],
        [contactKey]: newValue
      };
    }
    
    // Mettre à jour formData avec la nouvelle valeur et les contacts synchronisés
    setFormData((prev: ExtendedMarkerData) => ({
      ...prev,
      [key]: newValue,
      contacts: updatedContacts
    }));
  };

  return (
    <ContactField>
      <Icon className="field-icon" size={14} />
      <Input
        type={type}
        placeholder={placeholder}
        value={(formData[key] as string) || ''}
        onChange={handleChange}
        error={error}
        disabled={isReadOnly}
      />
    </ContactField>
  );
};

